import { Contact } from '../../../../interfaces/users.interface';
import { getCompanySites } from '../../../../services/companyDetail';
import { useCompanyResource } from '../../../Vendors/useCompanyResource';

export interface UseCompanySitesResult {
  sites: Contact[];
  count: number;
  loading: boolean;
  error: boolean;
  refetch: () => void;
}

/**
 * Fetches a page of a company's sites from the company-detail sites endpoint.
 * Thin wrapper around {@link useCompanyResource} preserving the `sites` field name.
 */
export function useCompanySites(
  companyId: number | undefined,
  page: number,
  pageSize: number,
  search?: string,
  siteIds?: string,
): UseCompanySitesResult {
  const { items, count, loading, error, refetch } = useCompanyResource<Contact>(
    getCompanySites,
    companyId,
    page,
    pageSize,
    true,
    search,
    siteIds,
  );
  return { sites: items, count, loading, error, refetch };
}
